import { SET_COMPANY_DATA, SET_COMPANY_REGISTRATION_DATA } from '../../actionTypes/company'

export const setCompanyRegistrationData = value => ({ type: SET_COMPANY_REGISTRATION_DATA, value })

export const setCompanyData = value => ({ type: SET_COMPANY_DATA, value })
